import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
    //Kullanıcı login olmuş mu ?
    //Kullanıcı login olmamışsa yönlendirme işlemini yap!
    // Kullanıcı login olmuşsa children'ı return et!
    const { token } = useSelector((state) => state.auth);
    const effectiveToken = token || localStorage.getItem('token');

    if (!effectiveToken) {
        return <Navigate to="/auth/login" replace />;
    }

    return children;
}
